exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Input__input___JOAm_ input,\n.Input__input___JOAm_ input:focus,\n.Input__input___JOAm_ textarea,\n.Input__input___JOAm_ textarea:focus {\n    background: #efefef;\n    border: 0;\n    border-bottom: 2px solid #efefef;\n    border-radius: 0;\n}\n\n.Input__input___JOAm_.Input__error___1R2wa input {\n    border-bottom: 2px solid red;\n}\n\n.Input__input___JOAm_.Input__light___11vkk input,\n.Input__input___JOAm_.Input__light___11vkk input:focus,\n.Input__input___JOAm_.Input__light___11vkk textarea,\n.Input__input___JOAm_.Input__light___11vkk textarea:focus {\n    background: #FFFFFF !important;\n    border-color: #FFFFFF;\n}\n", ""]);

// exports
exports.locals = {
	"input": "Input__input___JOAm_",
	"error": "Input__error___1R2wa",
	"light": "Input__light___11vkk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Input/Input.css
// module id = 378
// module chunks = 0